import { render, staticRenderFns } from "./CopyFile.vue?vue&type=template&id=58747deb&scoped=true&"
import script from "./CopyFile.vue?vue&type=script&lang=js&"
export * from "./CopyFile.vue?vue&type=script&lang=js&"
import style0 from "./CopyFile.vue?vue&type=style&index=0&id=58747deb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58747deb",
  null
  
)

export default component.exports